import { Component, OnInit } from '@angular/core';
import { LegFiJwtService } from '../../../services/auth/legfi-jwt.service';
import { ScrollService } from '../../../services/scroll.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../auth-layout-shared-styles.scss'],
})
export class LoginComponent implements OnInit
{
    isForwarding = false;

    constructor(
            private _scrollService: ScrollService,
    ) {
    }

    ngOnInit() {
        if (LegFiJwtService.raw() === 'false') {
            LegFiJwtService.clear();
        }

        // Scroll to top on view load.
        this._scrollService.scrollToTop();

        if (LegFiJwtService.read()) {
            this.isForwarding = true;
        }
    }
}

